// mapLocationResolver.js

export const isValidLatLng = (location) => {
  const latitude = Number(location?.latitude);
  const longitude = Number(location?.longitude);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return false;
  if (latitude < -90 || latitude > 90) return false;
  if (longitude < -180 || longitude > 180) return false;
  return true;
};

const toLocationList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  return [value];
};

export const extractNodeLocationPins = ({
  node,
  locationFields = [],
  resolveFieldValue,
}) => {
  if (!node?.key || typeof resolveFieldValue !== 'function') return [];

  const pins = [];

  locationFields.forEach((field) => {
    const fieldKey = String(field?.name || field?.key || '').trim();
    if (!fieldKey) return;

    const rawValue = resolveFieldValue(node, field);
    const locations = toLocationList(rawValue);

    locations.forEach((locationValue, index) => {
      if (!isValidLatLng(locationValue)) return;

      const latitude = Number(locationValue.latitude);
      const longitude = Number(locationValue.longitude);
      const locationTitle = String(locationValue?.title || '').trim();
      const locationTitleFull = String(locationValue?.titleFull || '').trim();
      const fieldLabel = String(field?.label || '').trim();
      const locationLabel = locationTitleFull || locationTitle;

      const markerTitleParts = [String(node?.title || 'Untitled Node').trim()];
      if (fieldLabel) markerTitleParts.push(`Field: ${fieldLabel}`);
      if (locationLabel) markerTitleParts.push(locationLabel);

      pins.push({
        id: `${node.key}:${fieldKey}:${index}`,
        nodeKey: node.key,
        fieldKey,
        fieldLabel,
        title: String(node?.title || 'Untitled Node').trim(),
        latitude,
        longitude,
        locationTitle,
        locationTitleFull,
        markerTitle: markerTitleParts.join(' - '),
        subtitle: locationTitleFull || locationTitle || fieldLabel,
      });
    });
  });

  return pins;
};
